module.exports = { id: "instagram", url: "/build/app/img/symbols.svg#instagram", viewBox: "", toString: function() { return this.url; } };